import { RouteObject } from "react-router-dom";
import { NotFound } from "../../../commons/components";
import { TeamDetailManage, TeamManage, TeamManageProfile, TeamManageSquad } from "../..";
import TeamManageStanding from "./TeamManageStanding";
import TeamManageEvents from "./TeamManageEvents";
import TeamManageStatistics from "./TeamManageStatistics";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import TeamManageSubTeams from "./TeamManageSubTeams";
import { routerAdminSubTeam } from "../subTeam/routesAdminSubTeam";
import TeamManageHostedTournament from "./TeamManageHostedTournament";
import { routerAdminHostedTournament } from "../hosted-tournament/routesAdminHostedTournament";

const TEAM_PROFILE = "profile";
const TEAM_SQUAD = "squad";
const TEAM_STATISTICS = "statistics";
const TEAM_STANDING = "standings";
const TEAM_EVENTS = "events";
const TEAM_SUB_TEAMS = "sub-teams";
const TEAM_HOSTED_TOURNAMENT = "hosted-tournaments";

export const routerAdminTeam: RouteObject[] = [
  {
    path: "",
    element: (
      <AuthGuardWrapper subject={ManageFootballTeam}>
        <TeamManage />
      </AuthGuardWrapper>
    ),
  },
  {
    path: ":teamId",
    element: (
      <AuthGuardWrapper subject={ManageFootballTeam}>
        <TeamDetailManage />
      </AuthGuardWrapper>
    ),
    children: [
      { index: true, element: <TeamManageProfile /> },
      { path: TEAM_PROFILE, element: <TeamManageProfile /> },
      { path: TEAM_SQUAD, element: <TeamManageSquad /> },
      { path: TEAM_STATISTICS, element: <TeamManageStatistics /> },
      { path: TEAM_STANDING, element: <TeamManageStanding /> },
      { path: TEAM_EVENTS, element: <TeamManageEvents /> },
      { path: TEAM_SUB_TEAMS, element: <TeamManageSubTeams /> },
      { path: TEAM_HOSTED_TOURNAMENT, element: <TeamManageHostedTournament /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: ":teamId/sub-teams/:subTeamId",
    children: routerAdminSubTeam,
  },
  {
    path: ":teamId/hosted-tournaments/:hostedCompetitionId",
    children: routerAdminHostedTournament,
  },
];
